<app-search-page [filter]="filter"
  [title]="title"
/>
